module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-envelope margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS6KEC2']['20']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-lg-10 clear-padding-lr"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 clearfix"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC2']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.indexSelected.numotgen))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 clearfix"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC2']['30']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "disabled": true,
      "data-vv-value-path": "inputDate",
      "name": "dtereq",
      "has-error": _vm.errors.has('dtereq')
    },
    model: {
      value: (_vm.detail.tab1.dtereq),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "dtereq", $$v)
      },
      expression: "detail.tab1.dtereq"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtereq')),
      expression: "errors.has('dtereq')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtereq')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 clearfix"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC2']['40']))]), _vm._v(" "), _c('hrms-lov-codcomp', {
    attrs: {
      "nowLang": _vm.nowLang,
      "name": "codcomp",
      "disabled": !_vm.validateProcess,
      "descDisp": false
    },
    model: {
      value: (_vm.detail.tab1.codcomp),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codcomp", $$v)
      },
      expression: "detail.tab1.codcomp"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 clearfix"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC2']['50']))]), _vm._v(" "), _c('hrms-lov', {
    attrs: {
      "lovType": "codcalen",
      "disabled": !_vm.validateProcess,
      "nowLang": _vm.nowLang,
      "name": "codcalen"
    },
    model: {
      value: (_vm.detail.tab1.codcalen),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codcalen", $$v)
      },
      expression: "detail.tab1.codcalen"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 clearfix"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC2']['55']))]), _vm._v(" "), _c('hrms-lov', {
    attrs: {
      "lovType": "codshift",
      "disabled": !_vm.validateProcess,
      "nowLang": _vm.nowLang,
      "name": "codshift"
    },
    model: {
      value: (_vm.detail.tab1.codshift),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codshift", $$v)
      },
      expression: "detail.tab1.codshift"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8 codempid-left"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC1']['20']))]), _vm._v(" "), _c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateCodempidQuery),
      expression: "validateCodempidQuery"
    }],
    attrs: {
      "lovType": "codempid",
      "disabled": !_vm.validateProcess,
      "nowLang": _vm.nowLang,
      "name": "codempid",
      "has-error": _vm.errors.has('codempid')
    },
    model: {
      value: (_vm.detail.tab1.codempid),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codempid", $$v)
      },
      expression: "detail.tab1.codempid"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codempid')),
      expression: "errors.has('codempid')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codempid')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 codempid-right"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button",
      "value": "Save",
      "disabled": !_vm.validateProcess
    },
    on: {
      "click": function($event) {
        _vm.callProcessCodempid()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['add']) + "\n                          ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['20']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['30']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|before:dteend'),
      expression: "'required|date_format:DD/MM/YYYY|before:dteend'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputDate",
      "name": "dtestrt",
      "has-error": _vm.errors.has('dtestrt')
    },
    model: {
      value: (_vm.detail.tab1.dtestrt),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "dtestrt", $$v)
      },
      expression: "detail.tab1.dtestrt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtestrt')),
      expression: "errors.has('dtestrt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtestrt')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['40']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:dtestrt'),
      expression: "'required|date_format:DD/MM/YYYY|after:dtestrt'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputDate",
      "name": "dteend",
      "has-error": _vm.errors.has('dteend')
    },
    model: {
      value: (_vm.detail.tab1.dteend),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "dteend", $$v)
      },
      expression: "detail.tab1.dteend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteend')),
      expression: "errors.has('dteend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['50']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['60']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbend|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbend|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputTime",
      "name": "timbstr",
      "has-error": _vm.errors.has('timbstr')
    },
    model: {
      value: (_vm.detail.tab1.timbstr),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "timbstr", $$v)
      },
      expression: "detail.tab1.timbstr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timbstr')),
      expression: "errors.has('timbstr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timbstr')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbstr|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbstr|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputTime",
      "name": "timbend",
      "has-error": _vm.errors.has('timbend')
    },
    model: {
      value: (_vm.detail.tab1.timbend),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "timbend", $$v)
      },
      expression: "detail.tab1.timbend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timbend')),
      expression: "errors.has('timbend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timbend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['70']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdend|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdend|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputTime",
      "name": "timdstr",
      "has-error": _vm.errors.has('timdstr')
    },
    model: {
      value: (_vm.detail.tab1.timdstr),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "timdstr", $$v)
      },
      expression: "detail.tab1.timdstr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timdstr')),
      expression: "errors.has('timdstr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timdstr')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdstr|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdstr|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputTime",
      "name": "timdend",
      "has-error": _vm.errors.has('timdend')
    },
    model: {
      value: (_vm.detail.tab1.timdend),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "timdend", $$v)
      },
      expression: "detail.tab1.timdend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timdend')),
      expression: "errors.has('timdend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timdend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['80']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timaend|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timaend|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputTime",
      "name": "timastr",
      "has-error": _vm.errors.has('timastr')
    },
    model: {
      value: (_vm.detail.tab1.timastr),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "timastr", $$v)
      },
      expression: "detail.tab1.timastr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timastr')),
      expression: "errors.has('timastr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timastr')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timastr|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timastr|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputTime",
      "name": "timaend",
      "has-error": _vm.errors.has('timaend')
    },
    model: {
      value: (_vm.detail.tab1.timaend),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "timaend", $$v)
      },
      expression: "detail.tab1.timaend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timaend')),
      expression: "errors.has('timaend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timaend')))])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 panel-codrem"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['90']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.arrCodrem[_vm.nowLang],
      "disabled": !_vm.validateStaappr || !_vm.validateProcess,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codrem",
      "has-error": _vm.errors.has('codrem')
    },
    model: {
      value: (_vm.detail.tab1.codrem),
      callback: function($$v) {
        _vm.$set(_vm.detail.tab1, "codrem", $$v)
      },
      expression: "detail.tab1.codrem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codrem')),
      expression: "errors.has('codrem')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codrem')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 panel-remark"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['95']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:200'),
      expression: "'required|max:200'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.tab1.remark),
      expression: "detail.tab1.remark"
    }],
    class: {
      'form-control': true, 'input-error': _vm.errors.has('remark')
    },
    attrs: {
      "name": "remark",
      "maxlength": "200",
      "disabled": !_vm.validateStaappr || !_vm.validateProcess
    },
    domProps: {
      "value": (_vm.detail.tab1.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail.tab1, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(600)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 panel-remark"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRMS6KEC2']['150']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detail.tab1.codinput) + " " + _vm._s(_vm.detail.tab1.name_codinput))])])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button",
      "disabled": !_vm.validateProcess
    },
    on: {
      "click": function($event) {
        _vm.callProcess()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['process']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    ref: "detailTab2",
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRMS6KEC3']['10']) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('hrms-table', {
    ref: "detailTab2Table",
    attrs: {
      "columns": _vm.detailTab2Table,
      "data": _vm.detail.tab2,
      "addInlineEventBool": true,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "deleteInlineBtnDisp": false,
      "saveInlineEvent": _vm.callSaveTab2,
      "columnEvent": _vm.columnEvent,
      "saveInlineBtnDisp": false,
      "loadingParentBool": _vm.loadingParentBool
    },
    on: {
      "setLoadingParentBool": function($event) {
        _vm.loadingParentBool = arguments[0]
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button",
      "value": "Save"
    },
    on: {
      "click": function($event) {
        _vm.postDetailSaveAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5f494c57!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms6ke/detail.vue
// module id = 3808
// module chunks = 1